<template>
  <img
    v-if="isShowImage"
    :src="validSrc"
    :alt="resolvedAlt"
    :class="{ hidden: !isShowImage }"
  >
  <div v-else>
    <slot />
  </div>
</template>

<script lang="ts">
export default {
  name: 'SImageByBase64',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from '../../composables';

const props = defineProps({
  src: {
    required: true,
    type: String,
  },
  alt: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const validSrc = ref('');
const isShowImage = ref(false);
const base64imagePrefixes = [
  'data:image/png;base64,',
  'data:image/svg+xml;base64,',
];

const resolvedAlt = computed(() => props.alt || t('imageAlt.genericImage'));

const image = document.createElement('img');
let currentPrefixIndex = 0;
image.src = `${base64imagePrefixes[currentPrefixIndex]}${props.src}`;
image.onerror = () => {
  if (base64imagePrefixes.length > currentPrefixIndex + 1) {
    currentPrefixIndex += 1;
    image.src = `${base64imagePrefixes[currentPrefixIndex]}${props.src}`;
  } else {
    image.onerror = null;
  }
};
image.onload = () => {
  isShowImage.value = true;
  validSrc.value = image.src;
};
</script>

<style scoped>
.hidden {
  height: 0;
  width: 0;
}
</style>
